import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const TravelTourismManagementPrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Tourism Operations",
    introduction: "Learn tourism industry operations and management principles.",
    buttonText: "LEARN MORE",
    route: "tourism-operations",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Customer Service Excellence",
    introduction: "Develop exceptional customer service and hospitality skills.",
    buttonText: "LEARN MORE",
    route: "customer-service-excellence",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Destination Management",
    introduction: "Learn destination planning, marketing, and sustainable tourism.",
    buttonText: "LEARN MORE",
    route: "destination-management",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Hotel Management",
    introduction: "Master hotel operations, front office, and housekeeping management.",
    buttonText: "LEARN MORE",
    route: "hotel-management",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Travel Agency Operations",
    introduction: "Learn travel booking systems and tour package development.",
    buttonText: "LEARN MORE",
    route: "travel-agency-operations",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80",
    heading: "Event Management",
    introduction: "Plan and manage tourism events and special occasions.",
    buttonText: "LEARN MORE",
    route: "event-management",
  },
];

const TravelTourismManagementProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={TravelTourismManagementPrograms}
        basePath="/courses/travel-tourism-management"
      />
    </div>
  );
};

export default TravelTourismManagementProgramsCard;
